import { raf } from './environment.js';

const tasks = new Set();

/**
 *
 *
 */
function run_tasks(now) {
	tasks.forEach((task) => {
		if (!task.c(now)) {
			tasks.delete(task);
			task.f();
		}
	});
	if (tasks.size !== 0) raf(run_tasks);
}

/**
 *
 *
 */
export function clear_loops() {
	tasks.clear();
}

/**
 *
 *
 *
 *
 */
export function loop(callback) {
	/*                                           */
	let task;
	if (tasks.size === 0) raf(run_tasks);
	return {
		promise: new Promise((fulfill) => {
			tasks.add((task = { c: callback, f: fulfill }));
		}),
		abort() {
			tasks.delete(task);
		}
	};
}
